import pathRoutes from "../../../routes/pathRoutes";
import { useSample } from "./useSample";
import { useAnalysisTypes } from "../../../../lib/servicesGenericsTables/useAnalysisType";
import dayjs from "dayjs";
import { Edit, Remove } from "@app/components/Actions";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { GridColDef } from "@mui/x-data-grid";
import { PermissionComponentGate } from "@app/utils/PermissionComponentGate";
import { RolesTypes } from "@app/pages/users/utils/helpers";

export const columnsSample = (handleOpenAudit): GridColDef[] => [
  { field: "id" },
  {
    field: "masl_reference",
    headerName: "Ref Muestra MASL",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "client_reference",
    headerName: "Ref Muestra cliente",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "installation",
    headerName: "Instalación",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.installation?.codigo || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    renderCell: (params) => <div>{params.value}</div>,
  },

  {
    field: "year",
    headerName: "Año",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "week",
    headerName: "Semana prevista",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "sample_type",
    headerName: "Tipo muestra",
    width: 200,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.sample_type?.codigo || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    renderCell: (params) => <div>{params.value}</div>,
  },

  {
    field: "sampling_points",
    headerName: "Pto. toma",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.sampling_points?.codigo || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    renderCell: (params) => <div>{params.value}</div>,
  },

  {
    field: "shared",
    headerName: "Compartida",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => <div>{params.row.shared ? "Si" : "No"}</div>,
  },
  {
    field: "accumulation",
    headerName: "Acumulación",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.accumulation?.code || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    renderCell: (params) => <div>{params.value}</div>,
  },

  {
    field: "reason",
    headerName: "Motivo",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.reason?.codigo || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    renderCell: (params) => <div>{params.value}</div>,
  },

  {
    field: "sample_number",
    headerName: "N° Muestras",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "analysis_type",
    headerName: "Análisis a realizar",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      const analysisAcc = params.row.analysis_type?.map((analysis) => {
        const data = useAnalysisTypes.getState().get(analysis.id);
        return data?.codigo || "";
      });

      return analysisAcc?.join(", ") || "";
    },
    sortComparator: (v1, v2) => {
      return v1.localeCompare(v2);
    },
    sortable: false,
    renderCell: (params) => <div>{params.value}</div>,
  },
  {
    field: "calculation_date",
    headerName: "Fecha del Cálculo",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.calculation_date || null;
    },
    sortComparator: (v1, v2) => {
      if (!v1) return 1;
      if (!v2) return -1;
      return new Date(v1).getTime() - new Date(v2).getTime();
    },
    sortable: false,
    renderCell: (params) => (
      <div>{params.value ? dayjs(params.value).format("DD/MM/YYYY") : ""}</div>
    ),
  },

  {
    field: "sampleManagement.date_start_reception",
    headerName: "Recepcionada",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    valueGetter: (params) => {
      return params.row.sampleManagement?.date_start_reception || null;
    },
    sortComparator: (v1, v2) => {
      if (!v1) return 1;
      if (!v2) return -1;
      return new Date(v1).getTime() - new Date(v2).getTime();
    },
    renderCell: (params) => (
      <div>{params.value ? dayjs(params.value).format("DD/MM/YYYY") : ""}</div>
    ),
  },

  {
    field: "actions",
    headerName: "Acciones",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <>
        <Edit to={`${pathRoutes.PORTAL_SAMPLES}/editar/${params.id}`} />
        <PermissionComponentGate
          permissions={[RolesTypes.ADMIN, RolesTypes.SUPER_ADMIN]}
        >
          <Remove onRemove={() => useSample.getState().remove(params.row.id)} />
        </PermissionComponentGate>
        <IconButton onClick={() => handleOpenAudit(params.row.id)}>
          <InfoIcon color="secondary" />
        </IconButton>
      </>
    ),
  },
];

export const columnsSampleAudit: GridColDef[] = [
  { field: "id" },
  {
    field: "fase",
    headerName: "Fase",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "analyst",
    headerName: "Analista",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
  {
    field: "date",
    headerName: "Fecha",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <div>
        {params.row.date ? dayjs(params.row.date).format("DD/MM/YYYY") : ""}
      </div>
    ),
  },
];

export const columnsPerformance: GridColDef[] = [
  { field: "id" },
  {
    field: "dateFrom",
    headerName: "Fecha inicio",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <div>
        {params.row.dateFrom
          ? dayjs(params.row.dateFrom).format("DD/MM/YYYY")
          : ""}
      </div>
    ),
  },
  {
    field: "dateTo",
    headerName: "Fecha cálculo",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
    renderCell: (params: any) => (
      <div>
        {params.row.dateTo ? dayjs(params.row.dateTo).format("DD/MM/YYYY") : ""}
      </div>
    ),
  },
  {
    field: "performance",
    headerName: "Rendimiento (días)",
    width: 100,
    headerAlign: "center",
    align: "center",
    flex: 1,
  },
];
